// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;In the shadow of your wings will I take refuge&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;until the storm of destruction has passed by.<br> </p> </div></div>";
// Exports
module.exports = code;